import { ProviderFeatureDiscoveryKey } from "../../recoil/types";
import { confirmLaunchTour } from "./Tours/confirmLaunch";
import { editOrderTour } from "./Tours/editOrder";
import { expandedCarrierScreenTour } from "./Tours/expandedCarrierScreen";
import { FeatureDiscoveryTour } from "./types";

export const featureDiscoveryTours: FeatureDiscoveryTour[] = [
  expandedCarrierScreenTour,
  editOrderTour,
  confirmLaunchTour,
];

// Add a tour key here when its Help Center entry should remain available but
// no longer carry the "New" badge.
export const newFeatureDiscoveryTourKey: ProviderFeatureDiscoveryKey =
  expandedCarrierScreenTour.featureKey;

// Automatic discovery prioritizes the tour currently marked New.
export const featureDiscoveryAutoOpenTours: FeatureDiscoveryTour[] = [
  ...featureDiscoveryTours.filter(
    (tour) => tour.featureKey === newFeatureDiscoveryTourKey,
  ),
  ...featureDiscoveryTours.filter(
    (tour) => tour.featureKey !== newFeatureDiscoveryTourKey,
  ),
];

export const featureDiscoveryTourRegistry = featureDiscoveryTours.reduce(
  (registry, tour) => ({
    ...registry,
    [tour.featureKey]: tour,
  }),
  {} as Record<ProviderFeatureDiscoveryKey, FeatureDiscoveryTour>,
);
